<template>
  <div class="model-warp" v-show="isShowModel">
    <div class="modal">

      <div class="title">
        <h3>付费</h3>
        <span @click="cancel">×</span>
      </div>

      <div class="content">
        <p class="price">￥{{price}}</p>
        <img :src="qrCode" alt="">
        <p>打开微信[扫一扫]</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaymentQrCode",
    props: {
      isShowModel: {
        default: false,
      },
      qrCode: {
        default: '',
      },
      price:{
        default:null,
      }
    },

    methods:{
      cancel(){
        this.$emit('showModel', false);
      }
    }
  }
</script>

<style scoped lang="less">
  .model-warp {
    position: fixed;
    z-index: 888;
    overflow: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(55, 55, 55, .6);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal {
      width: 400px;
      background-color: #fff;
      .title {
        height: 42px;
        line-height: 42px;
        display: flex;
        justify-content: space-between;
        color: #fff;
        background-color: #34404D;
        h3 {
          font-size: 16px;
          margin-left: 24px;
        }
        span {
          margin-right: 16px;
          cursor: pointer;
        }
      }

      .content {
        font-size: 14px;
        color: rgba(0, 0, 0, .85);
        text-align: center;
        padding-bottom: 40px;
        .price{
          font-size: 32px;
          color: #404040;
          margin: 32px 0;
        }
        img{
          display: block;
          margin: 0 auto 32px;
          width: 200px;
          height: 200px;
        }
        p{
          font-size: 16px;
          color: #595959;
        }
      }
    }
  }
</style>